import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ReloadOutlined } from '@ant-design/icons';
import SuccessMessage from '../../components/LoaderLottie';
import { useSelector } from 'react-redux';
import ButtonWrapper from '../../components/ButtonWrapper';
import { useNavigate, useParams } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: absolute;
`;

const Card = styled.div`
width: 500px;
  padding: 30px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;

   @media (max-width: 600px) {
    width: 95%;
    padding: 10px;
  }
`;

const Title = styled.p`
  font-size: 1rem;
  color: #333;
  margin: 0 0 20px;
`;

const Reference = styled.span`
  font-weight: bold;
  font-size: 1rem;
  display: block;
  margin: 10px 0;
`;

const Note = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin: 20px 0;
`;

const FpxRedirecting = () => {
  const navigation = useNavigate()
  const params = useParams();
  const [localLoader, setLoacalLoader] = useState(true)

  const {
    isLoading,
    error,
    data: verifyData,
  } = useSelector((state) => state.getVerifyManualTransactionReducer);

  const {
    data,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = useSelector((state) => state.postQrInitManualReducer);

  useEffect(() => {
    if(!data){
      navigation(`/myr/${params.id}`)
    }
  }, [])

  setTimeout(() =>{
    setLoacalLoader(false)
  }, 4000)
  
  return (
    <Container>
      <Card>
        <Title>Your payment Order Reference ID is:</Title>
        <Reference>{verifyData?.trxRef}</Reference>
        <Note>
          {`Please do not click on Back, Stop, Refresh buttons or close this window \n or tab while we process your payment.`}
        </Note>

        <form method="POST" action={data?.fpxUrl}>
          <input type="hidden" name="fpx_msgType" value={data?.fpx_msgType} />
          <input type="hidden" name="fpx_msgToken" value={data?.fpx_msgToken} />
          <input type="hidden" name="fpx_sellerExId" value={data?.fpx_sellerExId} />
          <input type="hidden" name="fpx_sellerExOrderNo" value={data?.fpx_sellerExOrderNo} />
          <input type="hidden" name="fpx_sellerTxnTime" value={data?.fpx_sellerTxnTime} />
          <input type="hidden" name="fpx_sellerOrderNo" value={data?.fpx_sellerOrderNo} />
          <input type="hidden" name="fpx_sellerId" value={data?.fpx_sellerId} />
          <input type="hidden" name="fpx_sellerBankCode" value={data?.fpx_sellerBankCode} />
          <input type="hidden" name="fpx_txnCurrency" value={data?.fpx_txnCurrency} />
          <input type="hidden" name="fpx_txnAmount" value={data?.fpx_txnAmount} />
          <input type="hidden" name="fpx_buyerEmail" value={data?.fpx_buyerEmail} />
          <input type="hidden" name="fpx_checkSum" value={data?.fpx_checkSum} />
          <input type="hidden" name="fpx_buyerName" value={data?.fpx_buyerName} />
          <input type="hidden" name="fpx_buyerBankId" value={data?.fpx_buyerBankId} />
          <input type="hidden" name="fpx_buyerBankBranch" value={data?.fpx_buyerBankBranch} />
          <input type="hidden" name="fpx_buyerAccNo" value={data?.fpx_buyerAccNo} />
          <input type="hidden" name="fpx_buyerId" value={data?.fpx_buyerId} />
          <input type="hidden" name="fpx_makerName" value={data?.fpx_makerName} />
          <input type="hidden" name="fpx_buyerIban" value={data?.fpx_buyerIban} />
          <input type="hidden" name="fpx_productDesc" value={data?.fpx_productDesc} />
          <input type="hidden" name="fpx_version" value={data?.fpx_version} />
          <input type="hidden" name="fpx_eaccountNum" value={data?.fpx_eaccountNum} />
          <input type="hidden" name="fpx_ebuyerID" value={data?.fpx_ebuyerID} />

          {qrInitLoading || isLoading || localLoader?
            <SuccessMessage width={"50%"} />
            :
            <ButtonWrapper
              isLoading={isLoading}
              border={true}
              bgColor="#003363"
              htmlType="submit"
              color="#fff"
              size="middle"
              height="40px"
              text="Click To Pay"
              // onClick={() => setLoacalLoader(true)}
            />}
        </form>
      </Card>
    </Container>
  );
};

export default FpxRedirecting;
